import { Box, Typography } from '@mui/material';
import React from 'react';

interface TimeBoxProps {
  label: string;
  value: string;
  width?: number | string;
  color?: string;
}

export const TimeBox: React.FC<TimeBoxProps> = ({ label, value, width, color }) => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <Typography fontSize="16px" fontWeight={400} color="#344054" lineHeight="24px">
        {label}
      </Typography>
      <Box
        sx={{
          display: 'flex',
          padding: '10px 14px',
          alignItems: 'center',
          gap: '8px',
          borderRadius: '8px',
          border: '1px solid var(--Gray-300, #D0D5DD)',
          background: 'var(--Base-White, #FFF)',
          boxShadow: '0 1px 2px 0 rgba(16, 24, 40, 0.05)',
          width: width || 'auto',
        }}
      >
        <Typography fontSize="16px" color={color || "#666"} lineHeight="24px" fontWeight={400}>
          {value}
        </Typography>
      </Box>
    </Box>
  );
};

export default TimeBox;
